import { useState, useEffect, useRef } from "react";
import styles from "./ui.module.css";

const CodeInput = ({ value, onChange }) => {
  const [digits, setDigits] = useState(['', '', '', '']);
  const inputsRef = useRef([]);

  useEffect(() => {
    // Синхронизация с внешним value
    if (value && value.length === 4) {
      setDigits(value.split(''));
    } else if (!value) {
      setDigits(['', '', '', '']);
    }
  }, [value]);

  const handleChange = (index, e) => {
    const newValue = e.target.value;
    
    // Разрешаем только цифры
    if (newValue && !/^[0-9]$/.test(newValue)) return;
    
    const newDigits = [...digits];
    newDigits[index] = newValue;
    setDigits(newDigits);
    
    // Объединяем цифры и передаем наружу
    const code = newDigits.join('');
    onChange(code);
    
    // Автоматический переход к следующему полю
    if (newValue && index < 3) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Обработка Backspace и удаления
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text/plain').trim();
    
    // Проверяем, что в буфере 4 цифры
    if (/^\d{4}$/.test(pasteData)) {
      const pastedDigits = pasteData.split('');
      setDigits(pastedDigits);
      onChange(pasteData);
      
      // Переводим фокус на последнее поле
      inputsRef.current[3].focus();
    }
  };

  return (
    <div className={styles.codeInputContainer}>
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          type="text"
          maxLength="1"
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          className={styles.codeInput}
          inputMode="numeric"
          autoFocus={index === 0}
        />
      ))}
    </div>
  );
};

export default CodeInput;